// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const AgentRole = {
    AGENT_ROLE_UNSPECIFIED: 'AGENT_ROLE_UNSPECIFIED',
    AGENT_ROLE_SUBAGENT: 'AGENT_ROLE_SUBAGENT',
    AGENT_ROLE_SUPERVISOR: 'AGENT_ROLE_SUPERVISOR',
    AGENT_ROLE_ALL: 'AGENT_ROLE_ALL',
};
export const AgentRoleValue = {
    AGENT_ROLE_UNSPECIFIED: 0,
    AGENT_ROLE_SUBAGENT: 1,
    AGENT_ROLE_SUPERVISOR: 2,
    AGENT_ROLE_ALL: 3,
};
export const NamespaceType = {
    NAMESPACE_TYPE_UNSPECIFIED: 'NAMESPACE_TYPE_UNSPECIFIED',
    NAMESPACE_TYPE_ACCOUNT_GROUP: 'NAMESPACE_TYPE_ACCOUNT_GROUP',
    NAMESPACE_TYPE_PARTNER: 'NAMESPACE_TYPE_PARTNER',
    NAMESPACE_TYPE_SYSTEM: 'NAMESPACE_TYPE_SYSTEM',
    NAMESPACE_TYPE_GLOBAL: 'NAMESPACE_TYPE_GLOBAL',
    NAMESPACE_TYPE_GROUP: 'NAMESPACE_TYPE_GROUP',
};
export const NamespaceTypeValue = {
    NAMESPACE_TYPE_UNSPECIFIED: 0,
    NAMESPACE_TYPE_ACCOUNT_GROUP: 1,
    NAMESPACE_TYPE_PARTNER: 2,
    NAMESPACE_TYPE_SYSTEM: 3,
    NAMESPACE_TYPE_GLOBAL: 4,
    NAMESPACE_TYPE_GROUP: 5,
};
export const ChatMessageRole = {
    CHAT_MESSAGE_ROLE_INVALID: 'CHAT_MESSAGE_ROLE_INVALID',
    CHAT_MESSAGE_ROLE_USER: 'CHAT_MESSAGE_ROLE_USER',
    CHAT_MESSAGE_ROLE_ASSISTANT: 'CHAT_MESSAGE_ROLE_ASSISTANT',
};
export const ChatMessageRoleValue = {
    CHAT_MESSAGE_ROLE_INVALID: 0,
    CHAT_MESSAGE_ROLE_USER: 1,
    CHAT_MESSAGE_ROLE_ASSISTANT: 2,
};
export const ChatChannel = {
    CHAT_CHANNEL_INVALID: 'CHAT_CHANNEL_INVALID',
    CHAT_CHANNEL_UNSPECIFIED: 'CHAT_CHANNEL_UNSPECIFIED',
    CHAT_CHANNEL_WEB: 'CHAT_CHANNEL_WEB',
    CHAT_CHANNEL_SMS: 'CHAT_CHANNEL_SMS',
    CHAT_CHANNEL_WHATSAPP: 'CHAT_CHANNEL_WHATSAPP',
    CHAT_CHANNEL_FACEBOOK: 'CHAT_CHANNEL_FACEBOOK',
    CHAT_CHANNEL_INSTAGRAM: 'CHAT_CHANNEL_INSTAGRAM',
    CHAT_CHANNEL_AUTOMATION: 'CHAT_CHANNEL_AUTOMATION',
    CHAT_CHANNEL_PLATFORM: 'CHAT_CHANNEL_PLATFORM',
    CHAT_CHANNEL_SNAPSHOT: 'CHAT_CHANNEL_SNAPSHOT',
    CHAT_CHANNEL_EMAIL: 'CHAT_CHANNEL_EMAIL',
};
export const ChatChannelValue = {
    CHAT_CHANNEL_INVALID: 0,
    CHAT_CHANNEL_UNSPECIFIED: 1,
    CHAT_CHANNEL_WEB: 2,
    CHAT_CHANNEL_SMS: 3,
    CHAT_CHANNEL_WHATSAPP: 4,
    CHAT_CHANNEL_FACEBOOK: 5,
    CHAT_CHANNEL_INSTAGRAM: 7,
    CHAT_CHANNEL_AUTOMATION: 8,
    CHAT_CHANNEL_PLATFORM: 9,
    CHAT_CHANNEL_SNAPSHOT: 10,
    CHAT_CHANNEL_EMAIL: 11,
};
export const ChatAnswerFunctionExecutionJobStatus = {
    FUNCTION_EXECUTION_JOB_STATUS_INVALID: 'FUNCTION_EXECUTION_JOB_STATUS_INVALID',
    FUNCTION_EXECUTION_JOB_STATUS_QUEUED: 'FUNCTION_EXECUTION_JOB_STATUS_QUEUED',
    FUNCTION_EXECUTION_JOB_STATUS_RUNNING: 'FUNCTION_EXECUTION_JOB_STATUS_RUNNING',
    FUNCTION_EXECUTION_JOB_STATUS_COMPLETE: 'FUNCTION_EXECUTION_JOB_STATUS_COMPLETE',
};
export const ChatAnswerFunctionExecutionJobStatusValue = {
    FUNCTION_EXECUTION_JOB_STATUS_INVALID: 0,
    FUNCTION_EXECUTION_JOB_STATUS_QUEUED: 1,
    FUNCTION_EXECUTION_JOB_STATUS_RUNNING: 2,
    FUNCTION_EXECUTION_JOB_STATUS_COMPLETE: 3,
};
export const AgentArchitecture = {
    UNSET: 'UNSET',
    STANDARD: 'STANDARD',
    REACT: 'REACT',
    DEEP_RESEARCH: 'DEEP_RESEARCH',
    SUPERVISOR: 'SUPERVISOR',
    GENERATION: 'GENERATION',
};
export const AgentArchitectureValue = {
    UNSET: 0,
    STANDARD: 1,
    REACT: 2,
    DEEP_RESEARCH: 3,
    SUPERVISOR: 4,
    GENERATION: 5,
};
export const ContentType = {
    CONTENT_TYPE_UNSPECIFIED: 'CONTENT_TYPE_UNSPECIFIED',
    REASONING: 'REASONING',
    ANSWER: 'ANSWER',
    ACTION_DESCRIPTION: 'ACTION_DESCRIPTION',
    WORKING: 'WORKING',
    ATTACHMENT: 'ATTACHMENT',
};
export const ContentTypeValue = {
    CONTENT_TYPE_UNSPECIFIED: 0,
    REASONING: 1,
    ANSWER: 2,
    ACTION_DESCRIPTION: 3,
    WORKING: 4,
    ATTACHMENT: 5,
};
export const CitationType = {
    UNSPECIFIED: 'UNSPECIFIED',
    USER_INPUT: 'USER_INPUT',
    BUSINESS_PROFILE: 'BUSINESS_PROFILE',
    WEBSITE: 'WEBSITE',
    FILE: 'FILE',
};
export const CitationTypeValue = {
    UNSPECIFIED: 0,
    USER_INPUT: 1,
    BUSINESS_PROFILE: 2,
    WEBSITE: 3,
    FILE: 4,
};
export const AttachmentType = {
    ATTACHMENT_TYPE_INVALID: 'ATTACHMENT_TYPE_INVALID',
    ATTACHMENT_TYPE_IMAGE: 'ATTACHMENT_TYPE_IMAGE',
    ATTACHMENT_TYPE_CHART: 'ATTACHMENT_TYPE_CHART',
};
export const AttachmentTypeValue = {
    ATTACHMENT_TYPE_INVALID: 0,
    ATTACHMENT_TYPE_IMAGE: 1,
    ATTACHMENT_TYPE_CHART: 2,
};
export const AssistantType = {
    ASSISTANT_TYPE_UNSPECIFIED: 'ASSISTANT_TYPE_UNSPECIFIED',
    ASSISTANT_TYPE_SYSTEM: 'ASSISTANT_TYPE_SYSTEM',
    ASSISTANT_TYPE_INBOX: 'ASSISTANT_TYPE_INBOX',
    ASSISTANT_TYPE_SOCIAL_MARKETING: 'ASSISTANT_TYPE_SOCIAL_MARKETING',
    ASSISTANT_TYPE_VOICE_RECEPTIONIST: 'ASSISTANT_TYPE_VOICE_RECEPTIONIST',
    ASSISTANT_TYPE_CUSTOM: 'ASSISTANT_TYPE_CUSTOM',
    ASSISTANT_TYPE_SALES_COACH: 'ASSISTANT_TYPE_SALES_COACH',
    ASSISTANT_TYPE_REPUTATION_MANAGEMENT_REVIEW_AGENT: 'ASSISTANT_TYPE_REPUTATION_MANAGEMENT_REVIEW_AGENT',
    ASSISTANT_TYPE_MARKETER: 'ASSISTANT_TYPE_MARKETER',
    ASSISTANT_TYPE_AEO_AND_SEO_EXPERT: 'ASSISTANT_TYPE_AEO_AND_SEO_EXPERT',
    ASSISTANT_TYPE_BLOGGER: 'ASSISTANT_TYPE_BLOGGER',
    ASSISTANT_TYPE_BUSINESS_APP_ASSISTANT: 'ASSISTANT_TYPE_BUSINESS_APP_ASSISTANT',
    ASSISTANT_TYPE_GENERATION: 'ASSISTANT_TYPE_GENERATION',
};
export const AssistantTypeValue = {
    ASSISTANT_TYPE_UNSPECIFIED: 0,
    ASSISTANT_TYPE_SYSTEM: 1,
    ASSISTANT_TYPE_INBOX: 2,
    ASSISTANT_TYPE_SOCIAL_MARKETING: 3,
    ASSISTANT_TYPE_VOICE_RECEPTIONIST: 4,
    ASSISTANT_TYPE_CUSTOM: 5,
    ASSISTANT_TYPE_SALES_COACH: 6,
    ASSISTANT_TYPE_REPUTATION_MANAGEMENT_REVIEW_AGENT: 7,
    ASSISTANT_TYPE_MARKETER: 8,
    ASSISTANT_TYPE_AEO_AND_SEO_EXPERT: 9,
    ASSISTANT_TYPE_BLOGGER: 10,
    ASSISTANT_TYPE_BUSINESS_APP_ASSISTANT: 11,
    ASSISTANT_TYPE_GENERATION: 12,
};
export const Action = {
    ACTION_UNSPECIFIED: 'ACTION_UNSPECIFIED',
    ACTION_ASSIGN: 'ACTION_ASSIGN',
    ACTION_VIEW: 'ACTION_VIEW',
    ACTION_INVOKE: 'ACTION_INVOKE',
};
export const ActionValue = {
    ACTION_UNSPECIFIED: 0,
    ACTION_ASSIGN: 1,
    ACTION_VIEW: 2,
    ACTION_INVOKE: 3,
};
export const Effect = {
    EFFECT_UNSPECIFIED: 'EFFECT_UNSPECIFIED',
    EFFECT_ALLOW: 'EFFECT_ALLOW',
    EFFECT_DENY: 'EFFECT_DENY',
};
export const EffectValue = {
    EFFECT_UNSPECIFIED: 0,
    EFFECT_ALLOW: 1,
    EFFECT_DENY: 2,
};
export const InvocationContextMedium = {
    UNSET_MEDIUM: 'UNSET_MEDIUM',
    VOICE: 'VOICE',
    TEXT: 'TEXT',
};
export const InvocationContextMediumValue = {
    UNSET_MEDIUM: 0,
    VOICE: 1,
    TEXT: 2,
};
export const InvocationContextChannel = {
    UNSET_CHANNEL: 'UNSET_CHANNEL',
    SMS: 'SMS',
    WEBCHAT: 'WEBCHAT',
    WHATSAPP: 'WHATSAPP',
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    EMAIL: 'EMAIL',
    PLATFORM: 'PLATFORM',
    SNAPSHOT: 'SNAPSHOT',
    SYSTEM: 'SYSTEM',
    PHONE: 'PHONE',
};
export const InvocationContextChannelValue = {
    UNSET_CHANNEL: 0,
    SMS: 1,
    WEBCHAT: 2,
    WHATSAPP: 3,
    FACEBOOK: 4,
    INSTAGRAM: 5,
    EMAIL: 6,
    PLATFORM: 7,
    SNAPSHOT: 8,
    SYSTEM: 9,
    PHONE: 10,
};
export const InvocationContextAuthState = {
    UNSET_AUTH_STATE: 'UNSET_AUTH_STATE',
    ANONYMOUS: 'ANONYMOUS',
    AUTHENTICATED: 'AUTHENTICATED',
};
export const InvocationContextAuthStateValue = {
    UNSET_AUTH_STATE: 0,
    ANONYMOUS: 1,
    AUTHENTICATED: 2,
};
export const InvocationContextApp = {
    UNSET_APP: 'UNSET_APP',
    BUSINESS_CENTER: 'BUSINESS_CENTER',
    PARTNER_CENTER: 'PARTNER_CENTER',
};
export const InvocationContextAppValue = {
    UNSET_APP: 0,
    BUSINESS_CENTER: 1,
    PARTNER_CENTER: 2,
};
export const FunctionParameterParameterLocation = {
    LOCATION_BODY: 'LOCATION_BODY',
    LOCATION_QUERY_PARAM: 'LOCATION_QUERY_PARAM',
};
export const FunctionParameterParameterLocationValue = {
    LOCATION_BODY: 0,
    LOCATION_QUERY_PARAM: 1,
};
export const GoalType = {
    GOAL_TYPE_INVALID: 'GOAL_TYPE_INVALID',
    GOAL_TYPE_GOAL: 'GOAL_TYPE_GOAL',
    GOAL_TYPE_KNOWLEDGE: 'GOAL_TYPE_KNOWLEDGE',
    GOAL_TYPE_PERSONALITY: 'GOAL_TYPE_PERSONALITY',
    GOAL_TYPE_CUSTOM: 'GOAL_TYPE_CUSTOM',
};
export const GoalTypeValue = {
    GOAL_TYPE_INVALID: 0,
    GOAL_TYPE_GOAL: 1,
    GOAL_TYPE_KNOWLEDGE: 2,
    GOAL_TYPE_PERSONALITY: 3,
    GOAL_TYPE_CUSTOM: 4,
};
export const GoalChannel = {
    GOAL_CHANNEL_INVALID: 'GOAL_CHANNEL_INVALID',
    GOAL_CHANNEL_SMS: 'GOAL_CHANNEL_SMS',
    GOAL_CHANNEL_EMAIL: 'GOAL_CHANNEL_EMAIL',
    GOAL_CHANNEL_PLATFORM: 'GOAL_CHANNEL_PLATFORM',
    GOAL_CHANNEL_WEBCHAT: 'GOAL_CHANNEL_WEBCHAT',
    GOAL_CHANNEL_VOICE: 'GOAL_CHANNEL_VOICE',
    GOAL_CHANNEL_WHATSAPP: 'GOAL_CHANNEL_WHATSAPP',
    GOAL_CHANNEL_INSTAGRAM: 'GOAL_CHANNEL_INSTAGRAM',
    GOAL_CHANNEL_FACEBOOK: 'GOAL_CHANNEL_FACEBOOK',
    GOAL_CHANNEL_AUTOMATION: 'GOAL_CHANNEL_AUTOMATION',
    GOAL_CHANNEL_SNAPSHOT: 'GOAL_CHANNEL_SNAPSHOT',
    GOAL_CHANNEL_BROWSER_VOICE: 'GOAL_CHANNEL_BROWSER_VOICE',
};
export const GoalChannelValue = {
    GOAL_CHANNEL_INVALID: 0,
    GOAL_CHANNEL_SMS: 1,
    GOAL_CHANNEL_EMAIL: 2,
    GOAL_CHANNEL_PLATFORM: 3,
    GOAL_CHANNEL_WEBCHAT: 4,
    GOAL_CHANNEL_VOICE: 5,
    GOAL_CHANNEL_WHATSAPP: 6,
    GOAL_CHANNEL_INSTAGRAM: 7,
    GOAL_CHANNEL_FACEBOOK: 8,
    GOAL_CHANNEL_AUTOMATION: 9,
    GOAL_CHANNEL_SNAPSHOT: 10,
    GOAL_CHANNEL_BROWSER_VOICE: 11,
};
export const ModelVendor = {
    VENDOR_UNSET: 'VENDOR_UNSET',
    VENDOR_OPENAI: 'VENDOR_OPENAI',
    VENDOR_GOOGLE: 'VENDOR_GOOGLE',
    VENDOR_DEEPGRAM: 'VENDOR_DEEPGRAM',
};
export const ModelVendorValue = {
    VENDOR_UNSET: 0,
    VENDOR_OPENAI: 1,
    VENDOR_GOOGLE: 2,
    VENDOR_DEEPGRAM: 3,
};
export const ModelType = {
    TYPE_UNSET: 'TYPE_UNSET',
    TYPE_LARGE_LANGUAGE_MODEL: 'TYPE_LARGE_LANGUAGE_MODEL',
    TYPE_SPEECH_TO_TEXT: 'TYPE_SPEECH_TO_TEXT',
    TYPE_TEXT_TO_SPEECH: 'TYPE_TEXT_TO_SPEECH',
    TYPE_SPEECH_TO_SPEECH: 'TYPE_SPEECH_TO_SPEECH',
    TYPE_TEXT_TO_IMAGE: 'TYPE_TEXT_TO_IMAGE',
    TYPE_TEXT_TO_VIDEO: 'TYPE_TEXT_TO_VIDEO',
};
export const ModelTypeValue = {
    TYPE_UNSET: 0,
    TYPE_LARGE_LANGUAGE_MODEL: 1,
    TYPE_SPEECH_TO_TEXT: 2,
    TYPE_TEXT_TO_SPEECH: 3,
    TYPE_SPEECH_TO_SPEECH: 4,
    TYPE_TEXT_TO_IMAGE: 5,
    TYPE_TEXT_TO_VIDEO: 6,
};
export const VendorModel = {
    VENDOR_MODEL_UNSPECIFIED: 'VENDOR_MODEL_UNSPECIFIED',
    VENDOR_MODEL_OPEN_AI_REALTIME: 'VENDOR_MODEL_OPEN_AI_REALTIME',
    VENDOR_MODEL_DEEPGRAM: 'VENDOR_MODEL_DEEPGRAM',
    VENDOR_MODEL_ELEVEN_LABS: 'VENDOR_MODEL_ELEVEN_LABS',
    VENDOR_MODEL_OPEN_AI: 'VENDOR_MODEL_OPEN_AI',
};
export const VendorModelValue = {
    VENDOR_MODEL_UNSPECIFIED: 0,
    VENDOR_MODEL_OPEN_AI_REALTIME: 1,
    VENDOR_MODEL_DEEPGRAM: 2,
    VENDOR_MODEL_ELEVEN_LABS: 3,
    VENDOR_MODEL_OPEN_AI: 4,
};
export const VadType = {
    VAD_TYPE_UNSPECIFIED: 'VAD_TYPE_UNSPECIFIED',
    VAD_TYPE_SERVER_VAD: 'VAD_TYPE_SERVER_VAD',
    VAD_TYPE_SEMANTIC_VAD: 'VAD_TYPE_SEMANTIC_VAD',
};
export const VadTypeValue = {
    VAD_TYPE_UNSPECIFIED: 0,
    VAD_TYPE_SERVER_VAD: 1,
    VAD_TYPE_SEMANTIC_VAD: 2,
};
export const VadEagerness = {
    VAD_EAGERNESS_LOW: 'VAD_EAGERNESS_LOW',
    VAD_EAGERNESS_MEDIUM: 'VAD_EAGERNESS_MEDIUM',
    VAD_EAGERNESS_HIGH: 'VAD_EAGERNESS_HIGH',
};
export const VadEagernessValue = {
    VAD_EAGERNESS_LOW: 0,
    VAD_EAGERNESS_MEDIUM: 1,
    VAD_EAGERNESS_HIGH: 2,
};
export const AssistantTypeStatusStatus = {
    STATUS_INVALID: 'STATUS_INVALID',
    STATUS_ENABLED: 'STATUS_ENABLED',
    STATUS_DISABLED: 'STATUS_DISABLED',
    STATUS_COMING_SOON: 'STATUS_COMING_SOON',
};
export const AssistantTypeStatusStatusValue = {
    STATUS_INVALID: 0,
    STATUS_ENABLED: 1,
    STATUS_DISABLED: 2,
    STATUS_COMING_SOON: 3,
};
export const TestType = {
    TEST_TYPE_UNSPECIFIED: 'TEST_TYPE_UNSPECIFIED',
    TEST_TYPE_CHAT: 'TEST_TYPE_CHAT',
    TEST_TYPE_VOICE: 'TEST_TYPE_VOICE',
};
export const TestTypeValue = {
    TEST_TYPE_UNSPECIFIED: 0,
    TEST_TYPE_CHAT: 1,
    TEST_TYPE_VOICE: 2,
};
export const SortDirection = {
    SORT_DIRECTION_INVALID: 'SORT_DIRECTION_INVALID',
    SORT_DIRECTION_ASCENDING: 'SORT_DIRECTION_ASCENDING',
    SORT_DIRECTION_DESCENDING: 'SORT_DIRECTION_DESCENDING',
};
export const SortDirectionValue = {
    SORT_DIRECTION_INVALID: 0,
    SORT_DIRECTION_ASCENDING: 1,
    SORT_DIRECTION_DESCENDING: 2,
};
export const ScheduleTier = {
    SCHEDULE_TIER_UNSPECIFIED: 'SCHEDULE_TIER_UNSPECIFIED',
    SCHEDULE_TIER_NONE: 'SCHEDULE_TIER_NONE',
    SCHEDULE_TIER_DAILY: 'SCHEDULE_TIER_DAILY',
    SCHEDULE_TIER_WEEKLY: 'SCHEDULE_TIER_WEEKLY',
};
export const ScheduleTierValue = {
    SCHEDULE_TIER_UNSPECIFIED: 0,
    SCHEDULE_TIER_NONE: 1,
    SCHEDULE_TIER_DAILY: 2,
    SCHEDULE_TIER_WEEKLY: 3,
};
export const TriggerSource = {
    TRIGGER_SOURCE_UNSPECIFIED: 'TRIGGER_SOURCE_UNSPECIFIED',
    TRIGGER_SOURCE_MANUAL: 'TRIGGER_SOURCE_MANUAL',
    TRIGGER_SOURCE_SCHEDULED: 'TRIGGER_SOURCE_SCHEDULED',
};
export const TriggerSourceValue = {
    TRIGGER_SOURCE_UNSPECIFIED: 0,
    TRIGGER_SOURCE_MANUAL: 1,
    TRIGGER_SOURCE_SCHEDULED: 2,
};
export const BulkAutomationFilter = {
    BULK_AUTOMATION_FILTER_ALL: 'BULK_AUTOMATION_FILTER_ALL',
    BULK_AUTOMATION_FILTER_ONLY: 'BULK_AUTOMATION_FILTER_ONLY',
    BULK_AUTOMATION_FILTER_EXCLUDE: 'BULK_AUTOMATION_FILTER_EXCLUDE',
};
export const BulkAutomationFilterValue = {
    BULK_AUTOMATION_FILTER_ALL: 0,
    BULK_AUTOMATION_FILTER_ONLY: 1,
    BULK_AUTOMATION_FILTER_EXCLUDE: 2,
};
export const SessionEventType = {
    SESSION_EVENT_TYPE_INVALID: 'SESSION_EVENT_TYPE_INVALID',
    SESSION_EVENT_TYPE_MESSAGE: 'SESSION_EVENT_TYPE_MESSAGE',
    SESSION_EVENT_TYPE_THOUGHT: 'SESSION_EVENT_TYPE_THOUGHT',
    SESSION_EVENT_TYPE_TOOL_CALL: 'SESSION_EVENT_TYPE_TOOL_CALL',
    SESSION_EVENT_TYPE_PROPOSED_ACTION: 'SESSION_EVENT_TYPE_PROPOSED_ACTION',
};
export const SessionEventTypeValue = {
    SESSION_EVENT_TYPE_INVALID: 0,
    SESSION_EVENT_TYPE_MESSAGE: 1,
    SESSION_EVENT_TYPE_THOUGHT: 2,
    SESSION_EVENT_TYPE_TOOL_CALL: 3,
    SESSION_EVENT_TYPE_PROPOSED_ACTION: 4,
};
export const SessionProposedActionDataStatus = {
    INVALID: 'INVALID',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    SUPERSEDED: 'SUPERSEDED',
};
export const SessionProposedActionDataStatusValue = {
    INVALID: 0,
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    SUPERSEDED: 6,
};
export const ValidationFailureAction = {
    VALIDATION_FAILURE_ACTION_UNSPECIFIED: 'VALIDATION_FAILURE_ACTION_UNSPECIFIED',
    VALIDATION_FAILURE_ACTION_NONE: 'VALIDATION_FAILURE_ACTION_NONE',
    VALIDATION_FAILURE_ACTION_WARN: 'VALIDATION_FAILURE_ACTION_WARN',
    VALIDATION_FAILURE_ACTION_MODIFY: 'VALIDATION_FAILURE_ACTION_MODIFY',
    VALIDATION_FAILURE_ACTION_BLOCK: 'VALIDATION_FAILURE_ACTION_BLOCK',
    VALIDATION_FAILURE_ACTION_EXCEPTION: 'VALIDATION_FAILURE_ACTION_EXCEPTION',
};
export const ValidationFailureActionValue = {
    VALIDATION_FAILURE_ACTION_UNSPECIFIED: 0,
    VALIDATION_FAILURE_ACTION_NONE: 1,
    VALIDATION_FAILURE_ACTION_WARN: 2,
    VALIDATION_FAILURE_ACTION_MODIFY: 3,
    VALIDATION_FAILURE_ACTION_BLOCK: 4,
    VALIDATION_FAILURE_ACTION_EXCEPTION: 5,
};
export const ListGoalsRequestSortingOrder = {
    GOAL_SORTING_ORDER_ASCENDING: 'GOAL_SORTING_ORDER_ASCENDING',
    GOAL_SORTING_ORDER_DESCENDING: 'GOAL_SORTING_ORDER_DESCENDING',
};
export const ListGoalsRequestSortingOrderValue = {
    GOAL_SORTING_ORDER_ASCENDING: 0,
    GOAL_SORTING_ORDER_DESCENDING: 1,
};
